import * as constants from '../../constants'


export function setAccessToken(payload) {
    return {
        type: constants.SET_ACCESS_TOKEN,
        payload,
    }
}

export function setOffersData(payload) {
    return {
        type: constants.SET_OFFERS_DATA,
        payload,
    }
}
export function updateStep(payload) {
    return {
        type: constants.SET_UPDATE_STEP,
        payload,
    }
}
export function setRazorpayOrderID(payload) {
    return {
        type: constants.SET_RAZORPAY_ORDER_ID,
        payload,
    }
}

export function setSuccessfullRazorpayPayment(payload) {
    return {
        type: constants.SET_SUCCESSFULL_RAZORPAY_PAYMENT,
        payload,
    }
}
export function setCustomerData(payload) {
    return {
        type: constants.SET_CUSTOMER_DATA,
        payload,
    }
}
export function setLoading(payload) {
    return {
        type: constants.SET_DATA_LOADING,
        payload,
    }
}